<script lang="ts" module>
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';
	import type { SbImage } from '../types';

	export interface SimpleImageBlock extends SbBlokData {
		asset: SbImage;
		asset_desktop?: SbImage;
	}
</script>

<script lang="ts">
	import Image from '../components/image.svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLImageElement> {
		content: ISbStoryData<SimpleImageBlock>['content'];
	}

	let { content, ...other }: Props = $props();

	let hasDesktopAsset = $derived(
		content.asset_desktop?.filename ? content.asset_desktop.filename.length > 0 : false
	);
</script>

<Image
	class={['h-full w-full object-cover', { 'lg:hidden': hasDesktopAsset }]}
	src={content.asset.filename}
	alt={content.asset.alt}
	title={content.asset.title}
	{...other}
/>
{#if hasDesktopAsset}
	<Image
		class="h-full w-full object-cover max-lg:hidden"
		src={content.asset_desktop!.filename}
		alt={content.asset_desktop!.alt}
		title={content.asset_desktop!.title}
		{...other}
	/>
{/if}
